import { Box, Stack, TextField, Typography } from "@mui/material";

export default function BrandField({
  label,
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  showSupport,
  onContactSupport,
  readOnly = false,
}) {
  return (
    <Stack spacing={1}>
      <Typography sx={{ fontSize: 12, fontWeight: 500 }}>{label}</Typography>
      <TextField
        size="small"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        InputProps={{ readOnly }}
        error={Boolean(error)}
        helperText={error || ""}
        sx={{
          "& .MuiInputBase-root": {
            height: 40,
            ...(readOnly && { backgroundColor: "#efefef" }),
          },
          "& .MuiInputBase-input": {
            fontSize: 14,
            lineHeight: "20px",
          },
          "& .MuiFormHelperText-root": {
            marginLeft: 0,
            marginRight: 0,
            marginTop: "6px",
          },
        }}
      />
      {showSupport ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            mt: -0.5,
            flexWrap: "wrap",
          }}
        >
          <Typography
            component="span"
            onClick={onContactSupport}
            sx={{
              color: "#ee4d37",
              fontSize: 12,
              fontWeight: 600,
              cursor: "pointer",
              textDecoration: "underline",
              textUnderlineOffset: "2px",
              lineHeight: "18px",
              whiteSpace: "nowrap",
            }}
          >
            Contact Support
          </Typography>
          <Typography
            component="span"
            sx={{ fontSize: 12, color: "#808080", lineHeight: "18px" }}
          >
            if you want access to this brand dashboard.
          </Typography>
        </Box>
      ) : null}
    </Stack>
  );
}
